import {
  ACTION_CREATE_SITE__SUCCESS,
  ACTION_CREATE_SITE__FAIL,
  ACTION_CREATE_SITE__REQUEST,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_SITE__REQUEST:
    case ACTION_CREATE_SITE__SUCCESS:
      return null;

    case ACTION_CREATE_SITE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
